import httpClient from "./httpClient";

const base = "/zk-devices";

export function listZkDevices() {
  return httpClient.get(base).then((res) => res.data.data);
}
export function createZkDevice(payload) {
  return httpClient.post(base, payload).then((res) => res.data.data);
}
export function updateZkDevice(id, payload) {
  return httpClient.put(`${base}/${id}`, payload).then((res) => res.data.data);
}
export function deleteZkDevice(id) {
  return httpClient.delete(`${base}/${id}`).then((res) => res.data);
}
export function syncZkDeviceTime(id) {
  return httpClient.post(`${base}/${id}/sync-time`).then((res) => res.data.data);
}
export function queryZkDeviceTime(id) {
  return httpClient.post(`${base}/${id}/query-time`).then((res) => res.data.data);
}
export function rebootZkDevice(id) {
  return httpClient.post(`${base}/${id}/reboot`).then((res) => res.data.data);
}
export function listZkDeviceCommands(id) {
  return httpClient.get(`${base}/${id}/commands`).then((res) => res.data.data);
}
